var defaultText = {
  standard: 'Standard'
};
var ratingTexts = {
  1: defaultText,
  3: defaultText,
  11: defaultText,
  15: {
    standard: 'Luokitus'
  },
  18: defaultText
};

export { ratingTexts };
//# sourceMappingURL=Rating.texts.js.map
